module.exports = __webpack_public_path__ + "static/will-0a041b65eb6e06ceb1df23bd06436d31.jpeg";